import React, { useEffect, useState } from 'react';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import axios from 'axios';
import { Link } from 'react-router-dom';



function ListIdPdv(){

    // console.log(`HERE id is ${idChoose}`);
    const [data, setDate] = useState([])
    const [search, setSearch] = useState('');
    // const [open, setOpen] = useState('block')

    useEffect(() => {
        // axios.get(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT3}/list/id_pdv`)
        axios.get(`${process.env.REACT_APP_IP2}:${process.env.REACT_APP_PORT2}/list/id_pdv`)
            .then(res => {
                console.log(res.data);
                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])

    const scrollToTop = () =>{
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
    };

    const arr = data.filter((item) => {
        return search.toLowerCase() === ''
            ? item
            :  item._client_id.toLowerCase().includes(search.toLowerCase())
    })
    .map((data, index) => {

        return (
            <Link to={`/listarticles/${data.id_pdv}/${data._client_id}`}>
                <div className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-colors hover:border-indigo-300 hover:bg-indigo-50/40">
                    <h5 className="text-lg font-semibold tracking-tight text-slate-800">{data._client_id}</h5>
                        {/* <p className="font-normal text-slate-700 dark:text-slate-400">Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.</p> */}
                </div>
            </Link>
        )
    })
    return (
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
            {/* <Header /> */}
            <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <h1 className="text-xl font-semibold text-slate-800">Points de vente</h1>
                    <p className="text-sm text-slate-500">{data.length} point(s) de vente</p>
                </div>
                <div className="w-full sm:max-w-xs">
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                            type="text"
                            id="search"
                            placeholder="Rechercher un point de vente.."
                            onChange={(e) => setSearch(e.target.value)}
                            />
                    </div>
                </div>
            </div>
            <main>
                {/* <DefaultSidebar  isOpen={open} /> */}
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
                    {arr}
                </div>
                <button
                    type="button"
                    className="fixed bottom-16 right-6 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md hover:bg-slate-50"
                    onClick={() => scrollToTop()}
                    title="Remonter"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </button>
            </main>
        </div>
    )
}

export default ListIdPdv;
